import { render, staticRenderFns } from "./REF.vue?vue&type=template&id=76a169b1&"
import script from "./REF.vue?vue&type=script&lang=js&"
export * from "./REF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports